import { light } from "@material-ui/core/styles/createPalette";

export default {
	primary: '#3b70a4',
	primaryDark: '#275481',
	primaryDarkBlue: '#282C6F',
	subDarkBlue: '#5B5D85',
	loginBackground: '#F6F7F9',
	titlePrimary: '#1B63AA',
	subtitleColor: '#7C7D87',
	greyText: '#9AA5B2',
	buttonContainerBG: '#F6F7F9',
	clockGreyText: '#D1D4DC',
	lightPrimary: '#4aaeef',
	lightBlue: '#eff5f8',
	clockRecordBlue: '#5B5D85',
	white: '#ffffff',
	iconBG: '#EBF0F6',
	grey: '#aeaeae',
	lightGrey: '#EDEDED',
	text2Grey: '#565864',
	greySeparator: '#E0E0E0',
	divider: '#E4E4E4',
	tooltipPercentage: '#919497',
	disableButtonGrey: '#BDBDBD',
	darkGrey: '#525962',
	textGrey: '#7C7D87',
	popupTextButton: '#4AAEEF',
	greenClock: '#6BC167',
	greenLightClock: '#E0F6DF',
	greenClockHover: '#569A52',
	redClock: '#E74646',
	success: '#1baa40',
	failure: '#e02020',
	warning: '#eb8b2d',
	pageBackground: '#DFF1F6',
	lightPageBackground: '#E3F0F6',
	secondaryLight: '#E3F4FF',
	filledHover: '#0176AE',
	datepickerBG: "#FBFBFB",
	datepickerSeparator: '#E2EDF4',
	datepickerChooseBG: '#009EE3',
	horizontalSeparator: 'rgba(151, 151, 151, 0.2)',
	boxSeparator: '#c7d9eb',
	generalSeparator: '#979797',
	filterBorder: '#e7e7e8',
	coloredTableRow: '#fbfcfd',
	tableBackground: '#e8faff33',
	tableBackgroundOpacity: 'rgba(74,174,239,0.1)',
	tableDisableBackgroundOpacity: 'rgba(130,130,130,0.1)',
	opacity: 'rgba(0,0,0,0)',
	backgroundOpacity: 'rgba(151, 151, 151, 0.5)',
	filterIcon: 'rgba(82, 89, 98, 0.3);',
	subMenuBG: "#EDF8FF",
	selectOptionSelected: '#f3f3f3',
	selectOptionFocused: '#F6F7F9',
	green: '#83b252',
	red: '#f04d4d',
	brightRed: 'rgba(240, 77, 77, 0.1)',
	brightBlue: '#f6fafb',
	uploadBright: '#f4f6f7',
	selectRowColor: '#c9edff',
	greyBlue: '#b4d3f2',
	totalRow: '#eff4f8',
	totalColumn: '#EFF2F7',
	totalRowAndColumn: '#E0E9EF',
	darkBlue: 'rgb(59, 112, 164)',
	tableHeaders: '#2882b8',
	tableGrayHeaders: '#828282',
	repStatus: {
		NO_RESULTS: 'hsl(360, 79%, 63%)',
		TRANS_PENDING_CHECK: '#F2C94C',
		TRANS_PENDING_APPROVE: '#F2C94C',
		TRANS_APPROVE: 'hsl(145, 50%, 62%)',
		TRANS_VALID: 'hsl(145, 50%, 62%)',
		NO_TRANS_REQUIRED: '#BDBDBD',
		BEFORE_TRANS: '#EB8B2E',
		TRANS: '#F2C94C',
		TRANS_PAID: 'hsl(145, 50%, 62%)',
	},
};
